import React, { useEffect, useRef, useState } from 'react';
import { InfoIcon, iconButton } from '../components/ui';

// Lo que antes decían las leyendas fijas de cada columna: ahora se abre con el ícono de información.
const HELP = {
    Disponibles: {
        intro: 'Los updates de la versión que todavía se pueden liberar.',
        points: [
            <><strong>Para liberar</strong> muestra sólo lo que les falta a los clientes elegidos y se les puede publicar. <strong>Todos</strong> muestra la versión completa.</>,
            'Los botones de una fila actúan sólo sobre ese update, aunque haya otros tildados.',
            'Para actuar sobre varios, tildalos y usá la barra de abajo.',
            <>Un update <strong>General</strong> va a cualquier cliente. Uno <strong>Solo TEC</strong> va únicamente a TEC.</>,
        ],
    },
    Publicados: {
        intro: 'Lo que cada cliente ya tiene liberado en esta versión, agrupado por cliente.',
        points: [
            <><strong>Despublicar</strong> se lo quita al cliente y el update vuelve a Disponibles.</>,
            <><strong>Ignorar</strong> se lo quita y además deja de ofrecérselo.</>,
            <><strong>Hash cambió</strong> quiere decir que el zip se modificó después de publicarlo. <strong>Republicar</strong> les copia el zip nuevo a todos los clientes que lo tienen.</>,
            'Para actuar sobre varios, tildalos y usá la barra de abajo: alcanza a los clientes elegidos arriba.',
        ],
    },
    Ignorados: {
        intro: 'Updates que se decidió no entregarle a un cliente.',
        points: [
            'Un update ignorado no se le ofrece ni se le publica a ese cliente.',
            <><strong>Recuperar</strong> lo devuelve a Disponibles.</>,
            'El ícono de nota muestra el motivo, si se cargó uno.',
        ],
    },
};

// El ícono de información del título de una columna: con un clic abre un cuadro chico con lo que hace esa columna.
export default function ColumnHelp({ column, onOpenHelp }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        if (!open) return undefined;
        const onClickOutside = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
        document.addEventListener('mousedown', onClickOutside);
        document.addEventListener('keydown', onKey);
        return () => { document.removeEventListener('mousedown', onClickOutside); document.removeEventListener('keydown', onKey); };
    }, [open]);
    const { intro, points } = HELP[column];

    return (
        <span ref={ref}>
            <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-label={`Qué es ${column}`} title={`Qué es ${column}`} className={iconButton}><InfoIcon /></button>
            {open && (
                <div role="dialog" aria-label={`Ayuda de ${column}`} className="absolute z-20 top-12 left-2 right-2 p-4 bg-white border border-slate-300 rounded-xl shadow-xl shadow-zafiro-900/15 text-sm text-slate-700">
                    <p className="font-semibold text-slate-900">{column}</p>
                    <p className="mt-1">{intro}</p>
                    <ul className="mt-2 pl-4 list-disc space-y-1">{points.map((point, i) => <li key={i}>{point}</li>)}</ul>
                    <button type="button" onClick={() => { setOpen(false); onOpenHelp(); }} className="mt-3 text-xs font-semibold text-zafiro-600 hover:underline">Más en Ayuda</button>
                </div>
            )}
        </span>
    );
}
